module.exports = __webpack_public_path__ + "img/star-2.173be931.svg";